export type RouterPathsType = typeof routerPaths

export const routerPaths = {
  public: {
    login: {
      rootPath: '',
      pathName: 'login',
      default: '/',
    },
    forgotPassword: {
      rootPath: '',
      pathName: 'forgotPassword',
      default: '/forgot-password',
    },
  },
  private: {
    dashboard: {
      rootPath: '',
      pathName: 'dashboard',
      default: '/dashboard',
      changePassword: {
        rootPath: 'dashboard',
        pathName: 'changePassword',
        default: '/dashboard/change-password',
      },
      reports: ({
        accountId,
        path,
        startDate,
        endDate,
      }: {
        accountId?: number | string
        path?: string
        startDate?: string
        endDate?: string
      }) => {
        let url = '/dashboard/reports'
        if (accountId) {
          url = `${url}/${accountId}`
        }
        if (accountId) {
          url = `${url}?path=${path}`
        }
        if (startDate) {
          url = `${url}&startDate=${startDate}`
        }
        if (endDate) {
          url = `${url}&endDate=${endDate}`
        }

        return {
          rootPath: 'dashboard',
          pathName: 'report',
          default: url,
        }
      },
      users: {
        rootPath: 'dashboard',
        pathName: 'users',
        default: '/dashboard/users',
        updateUser: (id: string) => ({
          rootPath: 'users',
          pathName: 'updateUser',
          default: `/dashboard/users/update-user/${id}`,
        }),
        createUser: {
          rootPath: 'users',
          pathName: 'createUser',
          default: '/dashboard/users/create-user',
        },
      },
      orders: {
        rootPath: 'dashboard',
        pathName: 'orders',
        default: '/dashboard/orders',
        charge: {
          rootPath: 'orders',
          pathName: 'charge',
          default: '/dashboard/orders/charge',
        },
        uncharge: {
          rootPath: 'orders',
          pathName: 'uncharge',
          default: '/dashboard/orders/uncharge',
        },
        chargeDetails: (id: string) => ({
          rootPath: 'orders',
          pathName: 'chargeDetails',
          default: `/dashboard/orders/charge-details/${id}`,
        }),
        unchargeDetails: (id: string) => ({
          rootPath: 'orders',
          pathName: 'unchargeDetails',
          default: `/dashboard/orders/uncharge-details/${id}`,
        }),
      },
      batchActions: {
        rootPath: 'dashboard',
        pathName: 'batchActions',
        default: '/dashboard/batch-actions',
        detailsBatchActions: (id: string) => ({
          rootPath: 'batchActions',
          pathName: 'detailsBatchActions',
          default: `/dashboard/batch-actions/${id}`,
        }),
      },
      awarded: {
        rootPath: 'dashboard',
        pathName: 'awarded',
        default: '/dashboard/awarded',
        userByDocument: (document: string) => ({
          rootPath: 'awarded',
          pathName: 'awarded',
          default: `/dashboard/awarded?document=${document}`,
          update: `/dashboard/awarded?document=${document}&editAwarded=true`,
        }),
      },
      cards: {
        rootPath: 'dashboard',
        pathName: 'cards',
        default: '/dashboard/cards',
        consult: (searchParam?: string) => ({
          rootPath: 'cards',
          pathName: 'cardsConsult',
          default: searchParam
            ? `/dashboard/cards/consult?searchParam=${searchParam}`
            : '/dashboard/cards/consult',
        }),
        stock: (id?: string) => ({
          rootPath: 'cards',
          pathName: 'cardsStock',
          default: id
            ? `/dashboard/cards/stock?productId=${id}`
            : '/dashboard/cards/stock',
        }),
        cardDetails: (id: number | string) => ({
          rootPath: 'cards',
          pathName: 'cardDetails',
          default: `/dashboard/cards/card-details/${id}`,
        }),
      },
      faq: {
        rootPath: 'dashboard',
        pathName: 'faq',
        default: '/dashboard/faq',
      },
    },
  },
}
